import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive'

export interface DeviceCellData {
  icon?: {
    url?: string
  }
  name: string
  deviceNumber: string
  paused?: boolean
  state?: {
    working: boolean
    stopped?: boolean
  }
  path?: string
  fullAddress?: string
  siteName?: string
}

@Component({
  selector: 'wm-front-device-cell',
  templateUrl: './device-cell.component.html',
  styleUrls: ['./device-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TooltipDirective],
})
export class DeviceCellComponent {
  /** The device type to display */
  @Input() public device?: DeviceCellData

  /** The path where it should redirect when being clicked on */
  @Input() public path: string

  /** The site which have the displayed device */
  @Input() public siteName?: string

  /** The address which have the displayed device */
  @Input() public fullAddress?: string

  /** If we want display the icon */
  @Input() public withIcon = true

  @Input() public withState = true

  private _router = inject(Router)

  private _route = inject(ActivatedRoute)

  public async navigateToProvidedPath(event: MouseEvent): Promise<void> {
    if (this.path) {
      const order = this._route.snapshot.queryParams['order']
      const navigationExtras = this._router.url.includes(
        'platform/units/by-status'
      )
        ? {
            queryParams: {
              ...this._route.snapshot.queryParams,
              order,
            },
          }
        : {}
      event.stopPropagation()
      await this._router.navigate([`${this.path}`], navigationExtras)
    }
  }
}
